import React from "react";
import { connect } from "react-redux";
import classes from "./OfflineOverlayHOC.scss";
import UIModal from "UIComponents/UIModal";
import { getHOCDisplayName } from "Utils";

function OfflineOverlayHOC(injectedProps) {
  return WrappedComponent => {
    class WithOfflineOverlay extends React.PureComponent {
      render() {
        const { forwardedRef, isOnline } = this.props;
        const { showOverlay } = injectedProps;

        return (
          <div className={classes.container}>
            <UIModal
              isOpen={isOnline === false && !!showOverlay}
              overlayContainer={classes.overlayContainer}
              modalContent={classes.modalContent}
            ></UIModal>
            <WrappedComponent ref={forwardedRef} {...this.props} />
          </div>
        );
      }
    }

    WithOfflineOverlay.defaultProps = {};

    WithOfflineOverlay.displayName = `WithOfflineOverlay(${getHOCDisplayName(
      WrappedComponent
    )})`;

    const mapActionCreators = {};

    const mapStateToProps = state => {
      return {
        isOnline: state.app_services.isOnline,
      };
    };
    return connect(
      mapStateToProps,
      mapActionCreators
    )(
      React.forwardRef(function WithOfflineOverlayForwardRef(props, ref) {
        return <WithOfflineOverlay {...props} forwardedRef={props.customRef} />;
      })
    );
  };
}

export default OfflineOverlayHOC;
